import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { USER_PROPERTIES_MANAGEMENT_ACTIONS } from '../actions';

const initialState = {
  properties: [],
};

const userPropertiesManagementReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case USER_PROPERTIES_MANAGEMENT_ACTIONS.GET_USER_PROPERTIES:
      return { ...state, properties: payload?.userProperties || [] };

    case USER_PROPERTIES_MANAGEMENT_ACTIONS.ADD_USER_PROPERTY: {
      const newProperty = _.get(payload, 'userProperties[0]');

      return { ...state, properties: [...state.properties, newProperty] };
    }

    case USER_PROPERTIES_MANAGEMENT_ACTIONS.EDIT_USER_PROPERTY: {
      const updatedProperty = _.get(payload, 'userProperties[0]');

      return {
        ...state,
        properties: state.properties.map(prevProperty =>
          prevProperty.name === updatedProperty?.name ? updatedProperty : prevProperty,
        ),
      };
    }

    case USER_PROPERTIES_MANAGEMENT_ACTIONS.DELETE_USER_PROPERTY:
      return {
        ...state,
        properties: state.properties.filter(({ name }) => name !== meta.property),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default userPropertiesManagementReducer;
